module.exports = __webpack_public_path__ + "img/logo.13ca027b.png";